


let audio = null;
let unlocked = false;

function getAudio() {
    if (!audio) {
        audio = new Audio("/ting.mp3");
        audio.volume = 1.0;
    }
    return audio;
}

function unlock() {
    if (unlocked) return;
    const a = getAudio();

    a.volume = 0;
    a.play()
        .then(() => {
            a.pause();
            a.currentTime = 0;
            a.volume = 1.0;
            unlocked = true;
        })
        .catch(() => { });
}


document.addEventListener("click", unlock, { once: true });
document.addEventListener("keydown", unlock, { once: true });

export function playTing() {
    const a = getAudio();
    a.currentTime = 0;
    a.volume = 1.0;
    a.play().catch(() => { });
}
